var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutubepost({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_2141",
    "data-name": "\\uC0AC\\uAC01\\uD615 2141",
    width: 24,
    height: 16.8,
    fill: "#a2a2a2"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_5101",
    "data-name": "\\uADF8\\uB8F9 5101",
    transform: "translate(8261 16532)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_5095",
    "data-name": "\\uADF8\\uB8F9 5095",
    transform: "translate(-8253 -16520)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_5094",
    "data-name": "\\uADF8\\uB8F9 5094",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD328\\uC2A4_280",
    "data-name": "\\uD328\\uC2A4 280",
    d: "M23.5,2.623A3.007,3.007,0,0,0,21.376.5C19.5,0,12,0,12,0S4.495,0,2.623.5A3.007,3.007,0,0,0,.5,2.623,31.238,31.238,0,0,0,0,8.4a31.241,31.241,0,0,0,.5,5.777A3.007,3.007,0,0,0,2.623,16.3c1.872.5,9.377.5,9.377.5s7.505,0,9.377-.5A3.007,3.007,0,0,0,23.5,14.176,31.241,31.241,0,0,0,24,8.4a31.238,31.238,0,0,0-.5-5.776M9.6,12V4.8l6.235,3.6Z",
    transform: "translate(0 0)",
    fill: "#a2a2a2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\uD0C0\\uC6D0_285",
    "data-name": "\\uD0C0\\uC6D0 285",
    transform: "translate(-8261 -16532)",
    fill: "none",
    stroke: "#a2a2a2",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.75,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubepost);
export default __webpack_public_path__ + "static/media/youtubepost.0dc38ba37c96aaa9b53ed63e98e98e6d.svg";
export { ForwardRef as ReactComponent };